import React, { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

export const ImageCarousel = ({ images = [], alt = "", className = "", testId = "image-carousel" }) => {
  const [idx, setIdx] = useState(0);
  const imgs = images.filter(Boolean);
  if (imgs.length === 0) return null;
  if (imgs.length === 1) {
    return <img src={imgs[0]} alt={alt} className={`w-full h-full object-cover ${className}`} data-testid={testId} />;
  }
  const go = (d) => setIdx((i) => (i + d + imgs.length) % imgs.length);
  return (
    <div className="relative w-full h-full group/carousel" data-testid={testId}>
      <img src={imgs[idx]} alt={alt} className={`w-full h-full object-cover ${className}`} data-testid={`${testId}-img`} />
      <button type="button" onClick={(e) => { e.preventDefault(); e.stopPropagation(); go(-1); }} aria-label="Previous photo" data-testid={`${testId}-prev`}
        className="absolute left-2 top-1/2 -translate-y-1/2 w-9 h-9 flex items-center justify-center bg-black/60 border border-[var(--twr-line-strong)] text-[var(--twr-warm-white)] hover:text-[var(--twr-bronze)] hover:border-[var(--twr-bronze)] transition-colors">
        <ChevronLeft size={16} />
      </button>
      <button type="button" onClick={(e) => { e.preventDefault(); e.stopPropagation(); go(1); }} aria-label="Next photo" data-testid={`${testId}-next`}
        className="absolute right-2 top-1/2 -translate-y-1/2 w-9 h-9 flex items-center justify-center bg-black/60 border border-[var(--twr-line-strong)] text-[var(--twr-warm-white)] hover:text-[var(--twr-bronze)] hover:border-[var(--twr-bronze)] transition-colors">
        <ChevronRight size={16} />
      </button>
      <div className="absolute bottom-3 left-0 right-0 flex justify-center gap-1.5">
        {imgs.map((_, i) => (
          <button key={i} type="button" aria-label={`Photo ${i + 1}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); setIdx(i); }}
            className={`w-1.5 h-1.5 rounded-full transition-colors ${i === idx ? "bg-[var(--twr-bronze)]" : "bg-white/40"}`} />
        ))}
      </div>
    </div>
  );
};

export const productImages = (p) => [p?.image, ...(p?.images || [])].filter(Boolean);
